<script>
import ToggleMixin from './mixins/toggle';
import SortTaxonsMixin from './mixins/sort-taxons';

import TaxonNestedListItem from './TaxonNestedListItem.vue';

export default {
  name: 'TaxonListItem',
  components: { TaxonNestedListItem },
  mixins: [ToggleMixin, SortTaxonsMixin],
  props: ['taxonomy'],
  computed: {
    orderedTaxons() {
      return this.sortTaxons(this.taxonomy.root.taxons);
    },
  },
};
</script>

<template>
  <li
    @mouseover="showChildren"
    @mouseleave="hideChildren"
    class="border-l-8 hover:bg-gray-diagomics-light relative">
    <div class="w-full p-2 text-blue-diagomics-dark block relative border-t cursor-default">
      {{ taxonomy.root.valid_name }}
      <span class="absolute text-gray-300 right-2"><i class="fa fa-caret-right"></i></span>
    </div>
    <ul class="w-64 absolute z-20 bg-white top-0 left-32 xl:left-44 border p-4 shadow-xl
              rounded-r-md rounded-b-md" v-if="childrenDisplayed">
      <TaxonNestedListItem :taxon="taxon" v-for="taxon in orderedTaxons" :key="taxon.id" />
    </ul>
  </li>
</template>
